import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Plus } from "lucide-react";
import Card from "@/components/common/Card";
import Layout from "@/components/layout/Layout";
import MainHeading from "@/components/common/MainHeading";
import { Button } from "@/components/ui/button";
import BranchSalaryHeadModal from "../../../components/BranchSalaryHead/BranchSalaryHeadModal";
import BranchSalaryHeadSection from "../../../components/BranchSalaryHead/BranchSalaryHeadSection";
import BranchSelector from "../../../components/BranchSalaryHead/BranchSelector";
import type {
    BranchSalaryHeadType,
    IBranchSalaryHead,
} from "../../../interface/branchSalaryHead.types";
import { useBranchSalaryHeadData } from "../../../hooks/useBranchSalaryHeadData";

const AddBrachSalaryHead: React.FC = () => {
    const { id } = useParams();
    const {
        branches,
        branchSalaryHeads,
        deleteBranchSalaryHead,
        isLoadingBranches,
        isLoadingBranchSalaryHeads,
        isLoadingSalaryHeads,
        isSubmitting,
        selectedBranchId,
        setSelectedBranchId,
        salaryHeads,
        submitBranchSalaryHead,
    } = useBranchSalaryHeadData(id);

    const [activeModal, setActiveModal] = useState<BranchSalaryHeadType | null>(null);
    const [editingItem, setEditingItem] = useState<IBranchSalaryHead | null>(null);

    const earningOptions = salaryHeads.filter((item) => item.type === "earning");
    // console.log("earningOptions", earningOptions)
    const deductionOptions = salaryHeads.filter((item) => item.type === "deduction");
    // console.log("deductionOptions", deductionOptions)
    const earningsList = branchSalaryHeads.filter((item) => item.salaryHead?.type === "earning");
    console.log("earningsList", earningsList)
    const deductionsList = branchSalaryHeads.filter((item) => item.salaryHead?.type === "deduction");
    console.log("deductionsList", deductionsList)

    const openCreateModal = (type: BranchSalaryHeadType) => {
        setEditingItem(null);
        setActiveModal(type);
    };

    const openEditModal = (item: IBranchSalaryHead) => {
        if (!item.salaryHead || item.salaryHead.isBase) return;

        setEditingItem(item);
        setActiveModal(item.salaryHead.type as BranchSalaryHeadType);
    };

    const closeModal = () => {
        setActiveModal(null);
        setEditingItem(null);
    };

    const handleModalSubmit = async (salaryHeadId: string, amount: string, isFixed: boolean) => {
        if (!activeModal) return false;

        return submitBranchSalaryHead({
            type: activeModal,
            salaryHeadId,
            amount,
            isFixed,
            editingItem,
        });
    };

    return (
        <Layout>
            <div className="space-y-6">
                <MainHeading title="Add Branch Salary Head" isBackButtonVisible />

                {!id && (
                    <BranchSelector
                        branches={branches}
                        isLoading={isLoadingBranches}
                        selectedBranchId={selectedBranchId}
                        onChange={setSelectedBranchId}
                    />
                )}

                <div className="flex flex-wrap justify-end gap-4 pt-2">
                    <Button type="button" onClick={() => openCreateModal("earning")}>
                        <Plus className="h-5 w-5" /> Add Earning
                    </Button>
                    <Button type="button" onClick={() => openCreateModal("deduction")} variant="destructive">
                        <Plus className="h-5 w-5" /> Add Deduction
                    </Button>
                </div>

                <Card className="p-6 border-slate-200/80 rounded-2xl shadow-sm">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <BranchSalaryHeadSection
                            type="earning"
                            items={earningsList}
                            isLoading={isLoadingBranchSalaryHeads}
                            isSubmitting={isSubmitting}
                            onEdit={openEditModal}
                            onDelete={deleteBranchSalaryHead}
                        />
                        <BranchSalaryHeadSection
                            type="deduction"
                            items={deductionsList}
                            isLoading={isLoadingBranchSalaryHeads}
                            isSubmitting={isSubmitting}
                            onEdit={openEditModal}
                            onDelete={deleteBranchSalaryHead}
                        />
                    </div>
                </Card>
            </div>

            {activeModal && (
                <BranchSalaryHeadModal
                    type={activeModal}
                    show={!!activeModal}
                    options={activeModal === "earning" ? earningOptions : deductionOptions}
                    editingItem={editingItem}
                    isLoadingOptions={isLoadingSalaryHeads}
                    isSubmitting={isSubmitting}
                    onClose={closeModal}
                    onSubmit={handleModalSubmit}
                />
            )}
        </Layout>
    );
};

export default AddBrachSalaryHead;
